export default "__VITE_PUBLIC_ASSET__308ddf4d__"